
/* injects from baggage-loader */

import { createSelector } from "reselect";
import Helpers from "../../helpers/helperFunctions";
import Config from "../../config/main";

export const getFavoriteCompetitionsSubscriptionData = (key) => {
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify((() => {
                const competitions = [];
                Object.keys(state.swarmData.data[key].sport).map((b) => {
                    let Sport = state.swarmData.data[key].sport[b],
                        Region = Sport.region;
                    Object.values(Region).forEach(region => {
                        Object.values(region.competition).forEach(comp => {
                            comp.sportAlias = Sport.alias;
                            comp.regionId = region.id;
                            comp.regionAlias = region.alias;
                            comp.regionName = region.name;
                            competitions.push(comp);
                        });
                    });
                });
                return competitions.sort((a, b) => a.favorite_order - b.favorite_order).splice(0, Config.homePageCompetitionsCount);
            })())
        ],
        (data) => {
            return {
                data: data && JSON.parse(data)
            };
        });
};